export function isProduktlyEnabled(): boolean {
  if (import.meta.env.DEV) {
    return false;
  }

  const clientToken =
    (import.meta.env.VITE_PRODUKTLY_CLIENT_TOKEN as string | undefined)
      ?.trim() ?? '';

  return clientToken.length > 0;
}
